import React, {Component} from "react";
import Select from "../../../../../components/select/Select";
import {withTranslation} from "react-i18next";
import styles from "./ContactTracingModale.module.css";
import Input from "../../../../../components/textbox/Input";
import Utils from "../../../../../utils/Utils";
import OggettiUtili from "../../../../../utils/OggettiUtili";
import _ from "lodash";
import Calendar from "../../../../../components/calendar/Calendar";
import Autocomplete from "../../../../../components/autocomplete/Autocomplete";
import CheckBox from "../../../../../components/checkbox/CheckBox";


class ContactTracingModale extends Component {
    state = {
        idContactTracing: null,
        cognome: "",
        nome: "",
        numero: "",
        dataNascita: "",
        recapitoTelefonico: "",
        dataContatto: "",
        comuneDomicilio: "",
        indirizzoDomicilio: "",
        note: "",
        disableSalva: true,
        provincia:"",
        dataSintomi: "",
        rintracciato: false,
        modalCssConsenso: ["modalConsenso", "triangle-down-modal-consenso", "btnBluOutline", "btnWhiteOutline", "containerConsenso", "modalHeader", "modalBody", "modalFooter"],
        comuni: Utils.distinctComuni(JSON.parse(sessionStorage.getItem("comuni"))),
        province: JSON.parse(sessionStorage.getItem("province")),
        tipologiaContatto:"",
        tipologiaContattoList: OggettiUtili.tipologiaContattoUtils,
        comuniPerCodice:JSON.parse(sessionStorage.getItem("comuniPerCodice")),
        provincePerCodice:JSON.parse(sessionStorage.getItem("provincePerCodice"))

    }

    constructor(props) {
        super(props);
        this.riceviValore = this.riceviValore.bind(this);
        this.onClickSalva = this.onClickSalva.bind(this);
        this.onClickAnnulla = this.onClickAnnulla.bind(this);
        this.onClickElimina = this.onClickElimina.bind(this);
        this.disabilitaSalva = this.disabilitaSalva.bind(this);
        this.riceviValoreSelect = this.riceviValoreSelect.bind(this);
    }

    componentDidMount() {
        if (this.props.contatto) {
            let contatto = this.props.contatto
            let state = _.cloneDeep(this.state)
            state.idContactTracing = contatto.idContactTracing;
            state.cognome = contatto.cognome;
            state.nome = contatto.nome;
            state.numero = contatto.numero;
            state.dataNascita = contatto.dataNascita;
            state.recapitoTelefonico = contatto.recapitoTelefonico;
            state.dataContatto = contatto.dataContatto;
            state.comuneDomicilio = contatto.comuneDomicilio && this.state.comuniPerCodice[contatto.comuneDomicilio] ? this.state.comuniPerCodice[contatto.comuneDomicilio] : "";
            state.indirizzoDomicilio=contatto.indirizzoDomicilio;
            state.note = contatto.note;
            state.provincia = contatto.provincia && this.state.provincePerCodice[contatto.provincia] ? this.state.provincePerCodice[contatto.provincia] : "";
            state.dataSintomi = contatto.dataSintomi;
            state.tipologiaContatto = contatto.tipologiaContatto;
            state.rintracciato = contatto.rintracciato? contatto.rintracciato : false;
            state.numero=contatto.numero;
            this.setState(state);
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.contatto !== this.props.contatto) {
            let contatto = this.props.contatto
            if (contatto) {
                let state = _.cloneDeep(this.state)
                state.idContactTracing = contatto.idContactTracing
                state.cognome = contatto.cognome;
                state.nome = contatto.nome;
                state.numero = contatto.numero;
                state.dataNascita = contatto.dataNascita;
                state.recapitoTelefonico = contatto.recapitoTelefonico;
                state.dataContatto = contatto.dataContatto;
                state.comuneDomicilio = contatto.comuneDomicilio && this.state.comuniPerCodice[contatto.comuneDomicilio] ? this.state.comuniPerCodice[contatto.comuneDomicilio] : "";
                state.indirizzoDomicilio=contatto.indirizzoDomicilio;
                state.note = contatto.note;
                state.provincia = contatto.provincia && this.state.provincePerCodice[contatto.provincia] ? this.state.provincePerCodice[contatto.provincia] : "";
                state.dataSintomi = contatto.dataSintomi;
                state.tipologiaContatto = contatto.tipologiaContatto;
                state.rintracciato = contatto.rintracciato? contatto.rintracciato : false;
                this.setState(state);
            }
        }
    }

     riceviValore(field, event) {
        let state = _.cloneDeep(this.state)
         if (field === "rintracciato" && event.target.value === "true") {
             state[field] = true
         } else if (field === "rintracciato" && event.target.value === "false") {
             state[field] = false
         } else {
             state[field] = event.target.value
         }
        state.disableSalva = this.disabilitaSalva(state)
        this.setState(state);
    }

    riceviValoreSelect(event) {
        
        let tipologia = ""
        tipologia = event.target.value
        let flag = false;
        if (this.state.nome === "" || this.state.cognome === "" || this.state.provincia==="" || this.state.comuneDomicilio===""
            || this.state.cognome.startsWith(" ") || this.state.nome.startsWith(" ") )
            flag = true
        this.setState({tipologiaContatto:tipologia, disableSalva: flag});
        
    }

    onClickSalva() {
        let jsoInsert = _.cloneDeep(this.state)
        jsoInsert.comuneDomicilio=jsoInsert.comuneDomicilio.codice ? jsoInsert.comuneDomicilio.codice : ""
        jsoInsert.provincia=jsoInsert.provincia.codice ? jsoInsert.provincia.codice : ""
        delete jsoInsert.modalCssConsenso
        delete jsoInsert.comuni
        delete jsoInsert.comuniPerCodice
        delete jsoInsert.province
        delete jsoInsert.tipologiaContattoList
        this.props.salvaContatto(jsoInsert, this.props.idSegnalazione)
        let state = {
            idContactTracing: null,
            cognome: "",
            nome: "",
            numero: "",
            dataNascita: "",
            recapitoTelefonico: "",
            dataContatto: "",
            provincia:"",
            comuneDomicilio: "",
            indirizzoDomicilio: "",
            tipologiaContatto:"",
            dataSintomi: "",
            rintracciato: false,
            note: "",
            disableSalva: true,
            modalCssConsenso: ["modalConsenso", "triangle-down-modal-consenso", "btnBluOutline", "btnWhiteOutline", "containerConsenso", "modalHeader", "modalBody", "modalFooter"]
        }
        this.setState(state)
    }

    onClickAnnulla() {
        let state = {
            idContactTracing: null,
            cognome: "",
            nome: "",
            numero: "",
            dataNascita: "",
            recapitoTelefonico: "",
            dataContatto: "",
            provincia:"",
            comuneDomicilio: "",
            indirizzoDomicilio: "",
            tipologiaContatto:"",
            dataSintomi: "",
            rintracciato: false,
            note: "",
            disableSalva: true,
            modalCssConsenso: ["modalConsenso", "triangle-down-modal-consenso", "btnBluOutline", "btnWhiteOutline", "containerConsenso", "modalHeader", "modalBody", "modalFooter"]
        }
        this.setState(state)
    }

    onClickElimina() {
        this.props.eliminaContatto(this.state.idContactTracing)
        let state = {
            idContactTracing: null,
            cognome: "",
            nome: "",
            numero: "",
            dataNascita: "",
            recapitoTelefonico: "",
            dataContatto: "",
            provincia:"",
            comuneDomicilio: "",
            indirizzoDomicilio: "",
            tipologiaContatto:"",
            dataSintomi: "",
            rintracciato: false,
            note: "",
            disableSalva: true,
            modalCssConsenso: ["modalConsenso", "triangle-down-modal-consenso", "btnBluOutline", "btnWhiteOutline", "containerConsenso", "modalHeader", "modalBody", "modalFooter"]
        }
        this.setState(state)
    }

    disabilitaSalva(state) {
        let flag = false;
        if (state.nome === "" || state.cognome === "" || state.provincia==="" || state.comuneDomicilio===""
            || state.cognome.startsWith(" ") || state.nome.startsWith(" ") )
            flag = true
        return flag
    }


    render() {
        const {t} = this.props
        return (
            <div className={("modal-body").concat(" " + styles[this.state.modalCssConsenso[6]])}
                 style={{textAlign: "left"}}>
                <div className="row">
                    <div className="col-4">
                        <p className={styles.testo}>{t("Tables.ContactTracing.cognome")} <span
                            className={styles.mandatoryColor}>*</span></p>

                        <Input id={"cognome"} onChange={this.riceviValore}
                               field={"cognome"}
                               value={this.state.cognome}
                               placeholder={"Inserisci cognome"}
                               onValidate={this.state.cognome ? (this.state.cognome.replace(/ +/g, "").length === 0
                               || this.state.cognome.startsWith(" ") ? 1 : 2) : 2}
                               errorMessage={"Cognome non valido"}
                        />
                    </div>
                    <div className="col-4">
                        <p className={styles.testo}>{t("Tables.ContactTracing.nome")} <span
                            className={styles.mandatoryColor}>*</span></p>
                        <Input id={"nome"} onChange={this.riceviValore}
                               field={"nome"}
                               value={this.state.nome}
                               placeholder={"Inserisci nome"}
                               onValidate={this.state.nome ? (this.state.nome.replace(/ +/g, "").length === 0
                               || this.state.nome.startsWith(" ") ? 1 : 2) : 2}
                               errorMessage={"Nome non valido"}

                        />
                    </div>
                    <div className="col-4">
                        <p className={styles.testo}>{t("Tables.ContactTracing.dataNascita")}</p>
                        <Calendar id={"dataNascita"}
                                  value={this.state.dataNascita}
                                  field={"dataNascita"}
                                  onChange={this.riceviValore}
                                  newCalendar={true}
                                  errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                      t("Tables.ContactTracing.dataNascita"))}
                                  error={(!this.state.dataNascita) ? false : Utils.isDateInValid(Utils.transformDateForBackend(this.state.dataNascita), "-")}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-4">
                        <p className={styles.testo}>{t("Tables.ContactTracing.dataContatto")}</p>
                        <Calendar id={"dataContatto"}
                                  value={this.state.dataContatto}
                                  field={"dataContatto"}
                                  onChange={this.riceviValore}
                                  newCalendar={true}
                                  errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                      t("Tables.ContactTracing.dataContatto"))}
                                  error={(!this.state.dataContatto) ? false : Utils.isDateInValid(Utils.transformDateForBackend(this.state.dataContatto), "-")}
                        />
                    </div>
                    <div className="col-6">
                        <p className={styles.testo}>{t("Tables.ContactTracing.recapitoTelefonico")}</p>
                        <Input id={"recapitoTelefonico"} onChange={this.riceviValore}
                               field={"recapitoTelefonico"}
                               value={this.state.recapitoTelefonico}
                               placeholder={"Inserisci recapito telefonico"}
                               onValidate={this.state.recapitoTelefonico ? (!Utils.isRecapitoTelefonicoValid(this.state.recapitoTelefonico)
                               || this.state.recapitoTelefonico.startsWith(" ") ? 1 : 2) : 2}
                               errorMessage={"Recapito telefonico non valido"}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-4">
                        <p className={styles.testo}>{t("Tables.ContactTracing.provinciaDomicilio")}
                        <span
                            className={styles.mandatoryColor}>*</span>
                        </p>
                        <Autocomplete id={"provincia"}
                                    value={this.state.provincia}
                                    keyField={"codice"}
                                    descriptionField={"descrizione"}
                                    suggestionField={"descrizione"}
                                    onChange={this.riceviValore}
                                    field={"provincia"}
                                    placeholder={"Inserisci provincia di domicilio"}
                                    suggestions={this.state.province}
                        >
                        </Autocomplete>
                    </div>
                    <div className="col-4">
                        <p className={styles.testo}>{t("Tables.ContactTracing.comuneDomicilio")} <span
                            className={styles.mandatoryColor}>*</span></p>
                        <Autocomplete id={"comuneDomicilio"}
                                      value={this.state.comuneDomicilio}
                                      keyField={"codice"}
                                      descriptionField={"descrizione"}
                                      suggestionField={"descrizione"}
                                      onChange={this.riceviValore}
                                      field={"comuneDomicilio"}
                                      placeholder={"Inserisci comune di domicilio"}
                                      suggestions={this.state.provincia.codice ?
                                          Utils.filtroProvinceComuni(this.state.provincia.codice, this.state.comuni, "codiceProvincia") : this.state.comuniPerCodice}
                                     
                        >
                        </Autocomplete>
                    </div>
                    <div className="col-4">
                        <p className={styles.testo}>{t("Tables.ContactTracing.indirizzoDomicilio")}</p>
                        <Input id={"indirizzoDomicilio"} onChange={this.riceviValore}
                               field={"indirizzoDomicilio"}
                               errorMessage={"Indirizzo domicilio non valido"}
                               value={this.state.indirizzoDomicilio}
                               placeholder={"Inserisci indirizzo Domicilio"}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-4">
                        <p className={styles.testo}>{t("Tables.ContactTracing.contatto")}</p>
                        <Select
                           id={"tipologiaContatto"}
                           value={this.state.tipologiaContatto}
                           onChange={this.riceviValoreSelect}
                           functionMap={Utils.mapToArray(
                            this.state.tipologiaContattoList
                                
                                ).map((oggetto) => {
                                    return (
                                        <option value={oggetto.codice}>
                                            {oggetto.descrizione}
                                        </option>
                                    );
                                })}
                           
                           field={"tipologiaContatto"}
                           
                        />

                        
                    </div>
                    <div className="col-4">
                        <p className={styles.testo}>{t("Tables.ContactTracing.dataInizioSintomi")}</p>
                        <Calendar id={"dataSintomi"}
                                  value={this.state.dataSintomi}
                                  field={"dataSintomi"}
                                  onChange={this.riceviValore}
                                  newCalendar={true}
                                  errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                      t("Tables.ContactTracing.dataSintomi"))}
                                  error={(!this.state.dataSintomi) ? false : Utils.isDateInValid(Utils.transformDateForBackend(this.state.dataSintomi), "-")}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-4">
                        <CheckBox id={"rintracciato"}
                                    checked={this.state.rintracciato}
                                    field={"rintracciato"}
                                    text={t("Tables.ContactTracing.contattoRintracciato")}
                                    onChange={this.riceviValore}
                                    newCheckbox={true}
                                    fontColor={"#1b7ea9"}
                                    fontSize={"16px"}
                        >
                        </CheckBox>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <p className={styles.testo}>{t("Tables.ContactTracing.note")}</p>
                        <Input type={"textarea"}
                               placeholder="note"
                               onChange={this.riceviValore}
                               value={this.state.note}
                               id="note"
                               field={"note"}
                               onValidate={this.note ? this.state.note.startsWith(" ") ? 1 : 2 : 0} /// onValidate: 1 errore,  altro valore ok
                               errorMessage={"Campo note non valido"}
                        />
                    </div>
                </div>


                <div className="row" style={{marginTop: "2rem", marginBottom: "2rem"}}>
                    <div className="col-4">
                        <button
                            id={"buttonKO"}
                            onClick={this.onClickAnnulla}
                            className={[styles.buttonAnnulla, this.state.modalCssConsenso[3]].join(" ").concat(" btn")}
                            data-dismiss="modal"
                            type="button">
                            ANNULLA
                        </button>
                    </div>
                    {this.props.idContactTracing !== null ?
                        <div className={"col-4"}>
                            <button
                                id={"buttonKO"}
                                onClick={this.onClickElimina}
                                className={[styles.buttonAnnulla, styles.btnWhiteOutlineElimina].join(" ").concat(" btn")}
                                data-dismiss="modal"
                                type="button">
                                ELIMINA
                            </button>
                        </div> :
                        <div className={"col-4"}></div>
                    }

                    <div className="col-4">
                        <button
                            id={"buttonOK"}
                            className={[this.state.modalCssConsenso[2], styles.buttonOk].join(" ").concat(" btn")}
                            data-dismiss="modal"
                            type="button"
                            onClick={this.onClickSalva}
                            // disabled={!this.state.cognome || !this.state.nome}
                            disabled={this.state.disableSalva}
                        >
                            SALVA
                        </button>
                    </div>
                </div>
            </div>


        )
            ;

    }
}

export default withTranslation('common')(ContactTracingModale);
